import { render } from "./HowtoTrad.vue?vue&type=template&id=22986fca"
import script from "./HowtoTrad.vue?vue&type=script&lang=js"
export * from "./HowtoTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__